import React from "react";
import { NextPage } from "next";

import { DataProcessingPersonalRoute as DataProcessingPersonal } from "scenes/DataProcessing";

const Index: NextPage = () => <DataProcessingPersonal />;

export default Index;
